import React from 'react';
import moment from 'moment';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import { formatDate, parseDate } from 'react-day-picker/moment';

import './rangePicker.css';

export default class Example extends React.Component {
  constructor(props) {
    super(props);
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.state = {
      from: undefined,
      to: undefined,
    };
  }

  showFromMonth() {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), 'months') < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  }

  handleFromChange(from) {
    this.setState({ from }, () => this.emitChange(from, this.state.to));
  }

  handleToChange(to) {
    this.setState({ to }, () => {
      this.showFromMonth();
      this.emitChange(this.state.from, to);
    });
  }

  emitChange(from, to) {
    if (!this.props.onChange) return;
    const fmt = (d) => (d ? moment(d).format('LL') : '');
    this.props.onChange(fmt(from), fmt(to));
  }

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    return (
      <div className="InputFromTo w-full">
        <span className="InputFromTo-from">
          <label className="block mb-2">Check in</label>
          <DayPickerInput
            value={from}
            placeholder="Checkin"
            format="LL"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: [from, { from, to }],
              disabledDays: { after: to },
              toMonth: to,
              modifiers,
              numberOfMonths: 2,
              onDayClick: () => this.to.getInput().focus(),
            }}
            onDayChange={this.handleFromChange}
            inputProps={{ readOnly: true }}
          />
        </span>
        <span className="InputFromTo-to">
          <label className="block mb-2">Check out</label>
          <DayPickerInput
            ref={(el) => (this.to = el)}
            value={to}
            placeholder="Checkout"
            format="LL"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: [from, { from, to }],
              disabledDays: { before: from },
              modifiers,
              month: from,
              fromMonth: from,
              numberOfMonths: 2,
            }}
            onDayChange={this.handleToChange}
            inputProps={{ readOnly: true }}
          />
        </span>
      </div>
    );
  }
}
